<ng-container [formGroup]="currentForm">
  <label class="text-lg text-blue-800 col-span-3">
    {{ label }}
  </label>
  <nz-textarea-count
    class="col-span-9"
    [nzMaxCharacterCount]="maxCharacterCount"
  >
    <textarea
      [placeholder]="placeholder"
      [formControlName]="attribute"
      nz-input
      [readOnly]="readOnly"
      [ngClass]="{ 'border-blue-600': !readOnly }"
    >
    </textarea>
  </nz-textarea-count>
</ng-container>
